import './Player.scss';
import SendFiles from "../SendFiles";
import Notify from "../Notify/Notify";
import de from "element-ui/src/locale/lang/de";

class Player {

    constructor() {

        this.contextList = [
            {
                label: 'Скачать',
                func: this.downloadVideo
            },
            {
                label: 'Отправить',
                func: this.sendVideo
            }
        ];

        this.contextMenu();
    }

    /**
     * Скачать видео
     * @param videoLink
     * @param tr
     */
    downloadVideo(videoLink, tr) {
        // videoLink = videoLink.replace('https://erlyvideo.v6.spb.ru/BATTLE/v7.spb./ru/', '/uploads/');
        let fileLink = document.createElement('a');
        fileLink.href = videoLink;
        fileLink.download = tr.getElementsByClassName('name')[0].textContent;
        document.body.append(fileLink);
        fileLink.click();
        fileLink.remove();
    }

    /**
     * Отправить видео
     * @param videoLink
     * @param tr
     */
    sendVideo(videoLink, tr) {

        let file = {
            url: videoLink,
            name: tr.getElementsByClassName('name')[0].textContent,
            date: tr.getElementsByClassName('format')[0].textContent
        };

        SendFiles.send([file], (res) => {
            if(res.error) {
                Notify.error(res.text);
            }
        });
    }

    /**
     * Повесить эвенты на строку с видео
     * Сохранить виртуальное меню
     */
    contextMenu() {

        this.renderContextMenu();

        $(document).on('contextmenu', '#bvideo tr', (event) => {
            this.menu.style.left = event.pageX + 'px';
            this.menu.style.top = event.pageY + 'px';
            document.body.append(this.menu);
            this.tr = event.currentTarget;
            document.addEventListener('click', () => {
                this.menu.remove()
            }, {once: true});
        });
    }

    /**
     * Получить ссылку на видео
     * @code ключ видео
     */
    decodeVideo(code) {
        return window.atob(code);
    }

    /**
     * Создать виртальное контекстное меню
     */
    renderContextMenu() {
        this.menu = document.createElement('div');
        this.menu.classList.add('player-menu');
        this.contextList.forEach((item) => {
            let menuItem = document.createElement('div');
            menuItem.classList.add('player-menu_item');
            menuItem.textContent = item.label;
            menuItem.addEventListener('click', (event) => {
                if(item.func) {
                    item.func(this.decodeVideo(this.tr.dataset.unique), this.tr);
                }
            });
            this.menu.append(menuItem);
        });
    }

    /**
     * Отрисовать плеер
     */
    renderPlayer() {
        let video = $('<video preload="auto"></video>');
        $('body').append($('<div id="bvideo" class="bvideo" style="position: fixed;"></div>'));
        $('#bvideo').append(video);
    }
}

export default Player;